import React from 'react';

export type SvgProps = React.SVGAttributes<SVGSVGElement>;

export default function createSvg<AdditionalProps extends object = {}>(
  component: React.FC<SvgProps & AdditionalProps>,
) {
  return component;
}
